const apiAccess = {
  apiAccess: {
    apiAccessTitle: 'Acesso API',
    apiAppContent: 'Com a API Enlighten Systems, os desenvolvedores de software podem escrever aplicativos externos que leem os dados de produção do sistema. Esses aplicativos podem solicitar que você insira um ID de usuário para fazer solicitações de API em seu nome. Seu ID de usuário é %{user_id}.',
    showApp: 'Mostrar aplicativos que têm acesso à API',
    isGrantedApp: 'Você não concedeu acesso à API para nenhum aplicativo.',
    apiSystemContent: 'Um aplicativo externo só pode recuperar dados para sistemas que permitem acesso à API. Isso é controlado pelo responsável pelo sistema. Se um sistema que você pode visualizar não estiver listado aqui, é porque o responsável optou por não permitir o acesso à API.',
    showSystem: 'Mostrar sistemas que permitem acesso à API',
    isGrantedSystem: 'Você não concedeu acesso de API a nenhum sistema.',
    revokeAccess: 'Revogar acesso'
  }
};

export default apiAccess;
